export default {
  init (vue) {
    return {
      query (data) {
        return vue.$http({
          method: 'POST',
          url: `/api/v1/eventtrack/query`,
          data: data
        })
      },
      queryEstimate (data) {
        return vue.$http({
          method: 'POST',
          url: `/api/v1/eventtrack/estimatead`,
          data: data
        })
      },
      queryEstimateDetails (data) {
        return vue.$http({
          method: 'POST',
          url: `/api/v1/eventtrack/estimateaddetails`,
          data: data
        })
      },
      updateCPCRule(data) {
        return vue.$http({
          method: 'PUT',
          url: `/api/v1/eventtrack/vivo/advertiserUpload/cpc`,
          data: data
        })
      },
      findGroupIdByCreative(advertiserId, creativeId) {
        return vue.$http({
          method: 'GET',
          url: `/api/v1/eventtrack/estimateadgroup/bycreative/${advertiserId}/${creativeId}`
        })
      }
    }
  }
}
